/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M0 4.2523C0 1.9038 1.9038 0 4.2523 0h12.3702c2.3484 0 4.2522 1.9038 4.2522 4.2523v3.0925c0 .6405-.5192 1.1597-1.1597 1.1597s-1.1597-.5192-1.1597-1.1597V4.2523c0-1.0675-.8654-1.9329-1.9328-1.9329H4.2523c-1.0675 0-1.9329.8654-1.9329 1.9329V19.715c0 1.0675.8654 1.9329 1.9329 1.9329H8.891c.6405 0 1.1597.5192 1.1597 1.1597s-.5192 1.1597-1.1597 1.1597H4.2523C1.9038 23.9673 0 22.0635 0 19.715V4.2523Z"
    />
    <path
      fill="currentColor"
      d="M16.4456 17.7245c.7063 0 1.2789-.5726 1.2789-1.279 0-.7063-.5726-1.2789-1.2789-1.2789-.7064 0-1.279.5726-1.279 1.2789 0 .7064.5726 1.279 1.279 1.279Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.4454 8.891c.6405 0 1.1597.5193 1.1597 1.1598v1.4109a5.0873 5.0873 0 0 1 1.5442.6401l.9981-.998c.4529-.4529 1.1871-.4529 1.64 0 .4529.4529.4529 1.1871 0 1.64l-.998.9981c.2927.4692.5114.9893.64 1.5439h1.4109c.6405 0 1.1597.5193 1.1597 1.1598 0 .6404-.5192 1.1597-1.1597 1.1597h-1.4109a5.0878 5.0878 0 0 1-.6401 1.5441l.9979.9979c.4529.4529.4529 1.1872 0 1.64-.4529.4529-1.1872.4529-1.6401 0l-.9979-.9979a5.0875 5.0875 0 0 1-1.5441.64v1.4109c0 .6405-.5192 1.1597-1.1597 1.1597s-1.1597-.5192-1.1597-1.1597v-1.411a5.0858 5.0858 0 0 1-1.5438-.64l-.998.998c-.4529.4529-1.1872.4529-1.6401 0-.4529-.4528-.4529-1.1871 0-1.64l.998-.998a5.088 5.088 0 0 1-.64-1.544h-1.411c-.6405 0-1.1597-.5193-1.1597-1.1597 0-.6405.5192-1.1598 1.1597-1.1598h1.411a5.0864 5.0864 0 0 1 .64-1.5439l-.998-.9981c-.4529-.4529-.4529-1.1871 0-1.64.4529-.4529 1.1871-.4529 1.64 0l.9981.998a5.0848 5.0848 0 0 1 1.5438-.64v-1.411c0-.6405.5192-1.1597 1.1597-1.1597Zm2.7966 7.5545c0 1.5445-1.252 2.7964-2.7964 2.7964-1.5444 0-2.7964-1.2519-2.7964-2.7964 0-1.5444 1.252-2.7963 2.7964-2.7963 1.5444 0 2.7964 1.2519 2.7964 2.7963Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.7985 6.1851c-.6404 0-1.1597.5192-1.1597 1.1597s.5193 1.1597 1.1597 1.1597H13.53c.6405 0 1.1597-.5192 1.1597-1.1597s-.5192-1.1597-1.1597-1.1597H5.7985ZM5.7985 12.3702c-.6404 0-1.1597.5192-1.1597 1.1597s.5193 1.1597 1.1597 1.1597h1.5463c.6405 0 1.1597-.5192 1.1597-1.1597s-.5192-1.1597-1.1597-1.1597H5.7985Z"
    />
  </React.Fragment>,
  'MenuReports'
);
